// extracted by css-extract-rspack-plugin
export default {"header":"Header-module__header__N5rZg","previewLabel":"Header-module__previewLabel__fT9j4"};